/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Department } from '../models/department';
import { getDepartments } from '../fn/department/get-departments';
import { GetDepartments$Params } from '../fn/department/get-departments';

@Injectable({ providedIn: 'root' })
export class DepartmentApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDepartments()` */
  static readonly GetDepartmentsPath = '/departments';

  /**
   * Retrieve all the departments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDepartments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDepartments$Response(params?: GetDepartments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Department>>> {
    const obs = getDepartments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve all the departments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDepartments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDepartments(params?: GetDepartments$Params, context?: HttpContext): Observable<Array<Department>> {
    const resp = this.getDepartments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Department>>): Array<Department> => r.body)
    );
  }

}
